import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-whatsuptemplate',
  templateUrl: './whatsuptemplate.component.html',
  styleUrls: ['./whatsuptemplate.component.scss']
})
export class WhatsuptemplateComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
